// API Base URL Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5002/api';

// Other global configurations
export const FILE_UPLOAD_SIZE_LIMIT = 10 * 1024 * 1024; // 10MB
export const DEFAULT_PAGINATION_LIMIT = 10;
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm'; 